import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { matchPath } from 'react-router';
import FontAwesome from 'react-fontawesome';

import { isMetaLoading } from '../../meta/meta';
import { auth } from '../../auth';
import { LOGIN_ROUTE } from '../../constants';

const TITLE_PREFIX = 'Reveal';
const TITLE_JOINER = ': ';
const TITLE_LINK_PATH = "/";
const TITLE_NO_OUTLET = 'Unknown Outlet';

const NO_USER_NAME = 'Unknown User';

const EMPTY_ARRAY = [];

const AUTH_LOADING_ICON = (
  <span><FontAwesome fixedWidth={true} spin={true} name="spinner" /> </span>
);

const AUTH_LOADING_ITEMS = [
  {
    id: 'auth-loading',
    label: 'Signing In...',
    icon: AUTH_LOADING_ICON
  }
];

const NAV_PRIMARY_LEFT_ITEMS = [
  {
    id: "link-dashboards",
    path: "/dashboards/",
    label: "Dashboards",
    icon: <span><FontAwesome fixedWidth={true} name="dashboard"/> </span>
  }
];

const DISCONNECTED_ITEM = {
  id: "link-disconnected",
  status: true,
  className: "disconnected-item",
  label: '',
  icon: <span className='server-disconnected'><FontAwesome fixedWidth={true} name="chain-broken" /> </span>
};

const AUTH_BASE_ITEM = {
  id: "link-user",
  icon: <span><FontAwesome fixedWidth={true} name="user" /> </span>,
  items: [
    {
      id: "link-logout",
      path: "/logout/",
      label: "Logout",
      icon: <span><FontAwesome fixedWidth={true} name="sign-out" /> </span>
    }
  ]
}

function getTitleForUser(me) {
  return (me && me.outlet_name) ? me.outlet_name : TITLE_NO_OUTLET;
}

function getUsernameForUser(me) {
  return (me && me.patron_name) ? me.patron_name : NO_USER_NAME;
}

export default class Auth extends PureComponent {
  static propTypes = {
    isConnected: PropTypes.bool.isRequired,
    authentication: PropTypes.object.isRequired,
    responsive: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    checkLogin: PropTypes.func.isRequired,
    requestLogout: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
  }

  componentWillMount() {
    auth.addExternalAuthenticationChangedListener(this.externalAuthenticationChanged);

    const { checkLogin } = this.props;
    checkLogin();
    this.possibleRedirectForAuth(null, this.props);
    this.possibleUpdateTitle(null, this.props);
  }

  externalAuthenticationChanged = () => {
    const { checkLogin } = this.props;
    checkLogin();
  }

  possibleRedirectForAuth(oldProps, nextProps) {
    const { history, authentication } = nextProps;
    const authChanged = oldProps === null || oldProps.authentication !== authentication;
    const didLogout = (oldProps === null || oldProps.authentication.get('authenticated') === true) &&
      authentication.get('authenticated') === false;
    if (authChanged && didLogout) {
      if (!matchPath(history.location.pathname, { path: LOGIN_ROUTE, exact: false, strict: false })) {
        let oldRoute = history.location.pathname; // save the current route to go back to it after successful login...
        history.replace({
          pathname: LOGIN_ROUTE,
          state: { nextPathname: oldRoute }
        });
      }
    }
  }

  possibleUpdateTitle(oldProps, nextProps) {
    const { authentication, me } = nextProps;
    let documentTitle = TITLE_PREFIX;
    if (authentication && authentication.get('authenticated') === true &&
        me !== undefined && me.outlet_name !== undefined) {
      documentTitle = TITLE_PREFIX + TITLE_JOINER + me.outlet_name;
    }
    document.title = documentTitle;
  }

  componentWillReceiveProps(nextProps) {
    this.possibleRedirectForAuth(this.props, nextProps);
    this.possibleUpdateTitle(this.props, nextProps);
  }

  componentWillUnmount() {
    auth.removeExternalAuthenticationChangedListener(this.externalAuthenticationChanged);
    this.possibleUpdateTitle(null, {});
  }

  render() {
    const { checkLogin, requestLogout, history, ...otherProps } = this.props;

    return (
      <AuthDetails {...otherProps}/>
    );
  }
}

class AuthDetails extends PureComponent {
  static propTypes = {
    responsive: PropTypes.object.isRequired,
    isConnected: PropTypes.bool.isRequired,
    meMeta: PropTypes.object.isRequired,
    me: PropTypes.object,
    endpointsMeta: PropTypes.object.isRequired,
    endpoints: PropTypes.object
  };

  constructor(props) {
    super(props);
  }

  getBrandItem() {
    const { me } = this.props;
    if (this._brandItem === void 0 || me !== this._me) {
      this._me = me;
      this._brandItem = me ? {
        label: getTitleForUser(me),
        path: TITLE_LINK_PATH
      } : null;
    }
    return this._brandItem;
  }

  getAuthLoading() {
    const { meMeta, endpointsMeta } = this.props;
    return isMetaLoading([meMeta, endpointsMeta]);
  }

  getNavPrimaryItems() {
    const { me, isConnected } = this.props;
    const authLoading = this.getAuthLoading();

    if (!me || this._me !== me || this._isConnected !== isConnected || this._authLoading !== authLoading) {
      this._authLoading = authLoading;
      this._me = me;
      this._isConnected = isConnected;
      if (me) {
        this._navPrimaryRightItems = [];
        if (!isConnected) {
          this._navPrimaryRightItems.push(DISCONNECTED_ITEM);
        }
        this._navPrimaryRightItems.push({
          ...AUTH_BASE_ITEM,
          label: getUsernameForUser(me)
        });
        this._navPrimaryLeftItems = NAV_PRIMARY_LEFT_ITEMS;
      }
      else {
        this._navPrimaryRightItems = authLoading ? AUTH_LOADING_ITEMS : EMPTY_ARRAY;
        this._navPrimaryLeftItems = EMPTY_ARRAY;
      }
    }
    return {
      primaryLeftItems: this._navPrimaryLeftItems,
      primaryRightItems: this._navPrimaryRightItems
    };
  }

  render() {
    const { renderChild, ...otherProps } = this.props;

    const title = getTitleForUser(this.props.me);

    const brandItem = this.getBrandItem();
    const { primaryLeftItems, primaryRightItems } = this.getNavPrimaryItems();

    const routeLoading = this.getAuthLoading();

    return renderChild({ routeLoading, brandItem, primaryLeftItems, primaryRightItems, title, ...otherProps});
  }
}
